import React, { FC } from 'react';
import Button from '../../../UIComponents/Button';
import { MdOutlineModeComment } from 'react-icons/md';
import { GrDatabase } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';
import routes from '../../../routes';
import { useAppDispatch, useAppSelector } from '../../../hooks/defaultHooks';
import { getIsAtLeastAdmin } from '../../../selectors/selectors';
import { Consumer } from '../consumer.types';
import { addChannel } from '../../../store/slices/messageChannelSlice';
import cls from './ConsumerActionButtons.module.scss';
import { closeOffcanvas } from '../../../store/slices/offcanvasSlice';
import { setLogsFieldSearch } from '../../../store/slices/logsFilterSlice';

type ConsumerActionButtonsProps = {
  consumer: Consumer | undefined;
};

const ConsumerActionButtons: FC<ConsumerActionButtonsProps> = ({ consumer }) => {
  const dispatch = useAppDispatch();
  const isAtLeastAdmin = useAppSelector(getIsAtLeastAdmin);
  const navigate = useNavigate();

  const sendMessageHandler = () => {
    dispatch(
      addChannel({
        email: consumer?.email as string,
        id: consumer?.id as string,
        name: consumer?.name as string,
      }),
    );
    dispatch(closeOffcanvas());
    navigate(routes.pages.messagePageByConsumerId(consumer?.id as string));
  };
  const redirectToLogsPage = () => {
    dispatch(closeOffcanvas());
    // the logs page filters by an account id: the one the log names as object or subject
    dispatch(setLogsFieldSearch({ key: 'objectId', value: consumer?.id ?? '' }));
    dispatch(setLogsFieldSearch({ key: 'objectEmail', value: consumer?.email ?? '' }));
    navigate(routes.pages.logsPage());
  };
  return (
    <div className={cls.Buttons} data-testid="button-part">
      <Button
        clickHandler={sendMessageHandler}
        Icon={<MdOutlineModeComment />}
        text={'Write'}
        className={cls.Button}
      />
      {isAtLeastAdmin && (
        <div className="link-logs text-center">
          <Button
            className={cls.Button}
            text={'Logs'}
            Icon={<GrDatabase />}
            clickHandler={redirectToLogsPage}
          />
        </div>
      )}
    </div>
  );
};

export default ConsumerActionButtons;
